import { useDispatch, useSelector } from 'react-redux';
import { subscriptionActions } from '../../../redux/slice/subscription.slice';
import BillingBody from './BillingBody';
import PricingBody from './PricingBody';
import styles from './pricingPlan.module.scss';

const PricingPlan = () => {

    const dispatch = useDispatch();

    const selectedPlan = useSelector(subscriptionActions.selectors.getSelectedPlan)
    const isYearly = useSelector(subscriptionActions.selectors.getIsYearlyBilling);
    const selectedTab = useSelector(subscriptionActions.selectors.getSelectedPricingTab)

    const handleChangeIsYearly = (isYearlyBilling) => {
        dispatch(subscriptionActions.actions.setIsYearlyBilling(isYearlyBilling))
    }

    const handleOpenContactUs = () => {
        window.open("https://bdata.ca", "_blank");
    }

    const handleSubmitPlan = (plan) => {
        if (plan?.name === "Custom Cloud") {
            handleOpenContactUs();
            return
        }
        if (selectedTab < 1) {
            dispatch(subscriptionActions.actions.setSelectedPricingTab(selectedTab + 1))
            dispatch(subscriptionActions.actions.setSelectedPlan(plan))
        }
    }

    const renderPricingTab = (tab) => {
        switch (tab) {
            case 0:
                return <PricingBody handleChangeIsYearly={handleChangeIsYearly} isYearly={isYearly} handleSubmitPlan={handleSubmitPlan} />
            case 1:
                return <BillingBody selectedPlan={selectedPlan} isYearly={isYearly} selectedTab={selectedTab} />
            default:
                return <PricingBody handleChangeIsYearly={handleChangeIsYearly} isYearly={isYearly} handleSubmitPlan={handleSubmitPlan} />
        }
    }

    return (
        <div className={styles.pricingContainer}>
            <div className={styles.pricingBodyContainer}>
                {renderPricingTab(selectedTab)}
            </div>
        </div>
    )
}

export default PricingPlan
